export default "/images/vendor/flag-icon-css/flags/1x1/fr.svg?d54aa958aeb0115ca87c9e73b2e82247";